import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { eventsKey, updateCalendarBlockRoute } from '@features/enterpriseEvents';
import axiosInstance from '@server/axiosInstance';
import { Job } from '@staffedupusa/shared-components';

type UseUpdateInterviewBlockProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  interviewBlockStartTime: number;
};
export const useUpdateInterviewBlock = ({
  setErrorText = () => { },
  interviewBlockStartTime,
}: UseUpdateInterviewBlockProps) => {
  const client = useQueryClient();

  const { mutate: updateInterviewBlock, isLoading: isUpdatingInterviewBlock } =
    useMutation({
      mutationFn: (variables: {
        calendar_block_id: number;
        start_time: number;
        end_time: number;
        eventDate: string;
        max_spots?: number;
        job_ids?: number[];
        delete_job_ids: boolean;
        delete_job_slots: boolean;
        block_type:number ,
      }) =>
        axiosInstance
          .post(updateCalendarBlockRoute, variables)
          .then((res) => res.data),
      onSuccess: (data, req) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([eventsKey]);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    updateInterviewBlock,
    isUpdatingInterviewBlock,
  };
};
